import SimpleModal from '../SimpleModal';

export default function GuideModal({ show, onClose }: { show: boolean; onClose: () => void }) {
  return (
    <SimpleModal show={show} onClose={onClose} title="Guide" size="lg">
      <div className="small lh-lg">
        <p>
          <strong>M3UStudio</strong> — edycja list M3U, kanałów i EPG. Wybierz playlistę w <strong>Playlist manager</strong>, potem
          otwórz edytor z menu <strong>Channels</strong>.
        </p>
        <ul className="mb-0">
          <li>
            <strong>Basic editor</strong> — pełna edycja kanału, przeciąganie kolejności, wybór wielu wierszy (zaznaczenia używane w
            narzędziach masowych z menu DNA).
          </li>
          <li>
            <strong>URL editor</strong> — zamiana fragmentu w URL strumienia lub logo (zakres: wszystkie / Basic / kategorie).
          </li>
          <li>
            <strong>Remove duplicates</strong>, <strong>Prefix/Suffix</strong>, <strong>Stream format</strong> — operacje na całej playliście lub zaznaczeniu.
          </li>
          <li>
            <strong>Undo / Redo</strong> — na górnym pasku; rejestruje ostatnie operacje masowe i edycje pól.
          </li>
        </ul>
      </div>
    </SimpleModal>
  );
}
